// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SignInForYourPriceComponent from "@store/Library/Components/SignInForYourPriceComponent";
import React from "react";

const enum fields {
    variantType = "variantType",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.variantType]: string;
    };
}

export interface SignInForYourPriceStyles {}

export const signInForYourPriceStyles: SignInForYourPriceStyles = {};

const styles = signInForYourPriceStyles;

const SignInForYourPrice = ({ fields: { variantType } }: OwnProps) => (
    <SignInForYourPriceComponent variant={variantType} />
);

const widgetModule: WidgetModule = {
    component: SignInForYourPrice,
    definition: {
        group: "Common",
        displayName: "Sign In For Your Price",
        icon: "button",
        fieldDefinitions: [
            {
                name: fields.variantType,
                displayName: "Format",
                fieldType: "General",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Button", value: "button" },
                    { displayName: "Link", value: "link" },
                ],
                defaultValue: "button",
                hideEmptyOption: true,
            },
        ],
    },
};

export default widgetModule;
